import { TState } from './types';

export const getInitialState = (props: Pick<TState, 'storeId'>): TState => ({
  focusedColumn: 1,
  focusedRow: 1,
  focusedId: 0,
  ...props,
});
